export default __webpack_public_path__ + "static/media/glasses12.2c85d0a4.jpeg";